import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
`;
interface IButtonSuggestionIcon {
  disabelPosition?: boolean;
  disabelCursorPointer?: boolean;
}
export const ButtonSuggestionIcon = styled.div<IButtonSuggestionIcon>`
  position: ${(prop) => prop.disabelPosition ? 'relative' : 'absolute'};;
  margin: 0;
  border: 0;
  background: transparent;
  right: ${(prop) => prop.disabelPosition ? 'unset' : '-12px'};
  top: ${(prop) => prop.disabelPosition ? 'unset' : '-12px'};
  cursor: ${(prop) => prop.disabelCursorPointer ? 'default' : 'pointer'};
`;